export const SET_JURIES  = 'SET_JURY';
export const ADD_JURY    = 'ADD_JURY';
export const UPDATE_JURY = 'UPDATE_JURY';
export const REMOVE_JURY = 'REMOVE_JURY';
